
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-pet-tag",
      function () {
        return require("private-next-pages/smart-pet-tag/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-pet-tag"])
      });
    }
  